export default __webpack_public_path__ + "static/media/eth-greet-black.4cd6bd7d.svg";